export const assertNeverReachable = (value: never): never => {
    throw new Error(`Unexpected value: ${value}`);
};
